package com.cybersoftsolution.cybersoftsolutionweb.use_cases

import com.cybersoftsolution.cybersoftsolutionweb.api.getPostById
import com.cybersoftsolution.cybersoftsolutionweb.api.getServerConfig
import com.cybersoftsolution.cybersoftsolutionweb.api.setServerConfig
import com.cybersoftsolution.cybersoftsolutionweb.components.toast.MyToastStyle
import com.cybersoftsolution.cybersoftsolutionweb.components.toast.showMyToast
import com.cybersoftsolution.cybersoftsolutionweb.models.Config
import com.cybersoftsolution.cybersoftsolutionweb.models.ui.AdminHomePageUI
import com.cybersoftsolution.cybersoftsolutionweb.models.ui.CreatePostUI
import com.cybersoftsolution.cybersoftsolutionweb.models.ui.ToastMessage
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.toastBasicID
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.delay


suspend fun CoroutineScope.setServerConfigUseCase(
    newServerConfig: Config,
    state: AdminHomePageUI,
    setLoading: (Boolean) -> Unit,
    setState: (AdminHomePageUI) -> Unit,
){
    val scope = this

    setLoading(true)

    setServerConfig(newServerConfig).also { response ->


//        delay(50)
        console.log(response)


        if (response != null)  {
            setState(
                state.copy(
                    serverConfig = response,
                )
            ).also {
                scope.showMyToast(toastBasicID)
            }

        } else {
            setState(
                state.copy(
                    toastMessage = ToastMessage(
                        message = "Error al obtener los datos",
                        style = MyToastStyle.Danger
                    )
                )
            ).also {
                scope.showMyToast(toastBasicID)
            }
        }




        setLoading(false)


    }
}